$(document).ready(function() {

  if (Math.random() < 0.5) {
    $('#web-stories-container').removeClass('d-none');
    $('#web-stories-container').addClass('d-lg-none');
  } else {

    const engageyaCircles     = $('#engageya-circles');
    const engageyaCirclesHome = $('#engageya-circles-home');

    if ($(engageyaCircles).length > 0) {
      $(engageyaCircles).removeClass('d-none');
      $(engageyaCircles).addClass('d-lg-none');
    } else {
      $(engageyaCirclesHome).removeClass('d-none');
      $(engageyaCirclesHome).addClass('d-lg-none');
    }

  }

  if ($('#web-stories-container').is(':visible')) {
    dataLayer.push({
      'event': 'ga_event',
      'eventCategory': 'Web Stories',
      'eventAction': 'Impressão',
      'eventLabel': 'Exibição do Web Stories',
    });

    gtag('event', 'Web Stories', {
      'eventAction': 'Impressão',
      'eventLabel': 'Exibição do Web Stories',
    });
  }

});
